import {
  Payout,
  PayoutItem,
  PayoutTransferPurpose,
  PayoutTransferStatus
} from "@wingspanhq/wingspan-api-sdk";

export function isInstantPayoutItem(item: PayoutItem) {
  return item.sourceSubType === "InstantPayoutDrawback";
}

export function getPayoutInvoiceIds(items: PayoutItem[]) {
  return items
    .filter(item => item.sourceType === "Invoice" && !isInstantPayoutItem(item))
    .map(item => item.sourceId);
}

export function getTotals(params: {
  payout: Payout;
  payoutItems: PayoutItem[];
  clearingItems: PayoutItem[];
  futureDebitItems: PayoutItem[];
  previousFutureDebitItems: PayoutItem[];
}) {
  const previousFutureDebitItemsTotal = Math.abs(
    calculateTotal(params.previousFutureDebitItems)
  );

  const payoutItemsTotal = calculateTotal(params.payoutItems);
  const clearingItemsTotal = calculateTotal(params.clearingItems);
  const futureDebitItemsTotal = calculateTotal(params.futureDebitItems);

  const netTotal = getPayoutNet(params.payout);

  const otherItemsTotal =
    netTotal - (previousFutureDebitItemsTotal + payoutItemsTotal);

  return {
    previousFutureDebitItems: params.previousFutureDebitItems,
    previousFutureDebitItemsTotal,
    payoutItems: params.payoutItems,
    payoutItemsTotal,
    clearingItems: params.clearingItems,
    clearingItemsTotal,
    futureDebitItems: params.futureDebitItems,
    futureDebitItemsTotal,
    otherItemsTotal,
    netTotal
  };
}

export function getPayoutNet(payout: Payout): number {
  const sentDisbursements = payout.transfers.filter(
    transfer =>
      transfer.purpose === PayoutTransferPurpose.DISBURSEMENT &&
      transfer.status === PayoutTransferStatus.SENT
  );

  if (sentDisbursements.length === 0) {
    return 0;
  }

  return Math.abs(calculateTotal(sentDisbursements));
}

function calculateTotal(items: Array<{ amount: number }>) {
  return items.reduce((acc, i) => acc + i.amount, 0);
}
